import FullLayout from '@/layouts/full/FullLayout.vue';
import type { RouteRecordRaw } from 'vue-router';

/**
 * Auditoria de Comodato — rota de permissão única `/auditoria-comodato` (migration 359), FECHADA por padrão.
 * member vê · editor liga/desliga, ajusta, reabre e exporta. As sub-rotas herdam (userRouteAccess.ts).
 */
export const auditoriaComodatoRoutes: RouteRecordRaw[] = [
  {
    path: '/auditoria-comodato',
    component: FullLayout,
    meta: { requiresAuth: true, title: 'Auditoria de Comodato' },
    children: [
      { path: '', name: 'AudComodatoPainel', component: () => import('@/views/AuditoriaComodato/PainelPage.vue'), meta: { requiresAuth: true, title: 'Auditoria de Comodato', breadcrumb: 'Auditoria de Comodato / Painel' } },
      { path: 'escolas', name: 'AudComodatoEscolas', component: () => import('@/views/AuditoriaComodato/EscolasPage.vue'), meta: { requiresAuth: true, title: 'Escolas', breadcrumb: 'Auditoria de Comodato / Escolas' } },
      { path: 'escolas/:id(\\d+)', name: 'AudComodatoEscola', component: () => import('@/views/AuditoriaComodato/EscolaDetalhePage.vue'), meta: { requiresAuth: true, title: 'Escola', breadcrumb: 'Auditoria de Comodato / Escolas / Escola' } },
      { path: 'itens', name: 'AudComodatoItens', component: () => import('@/views/AuditoriaComodato/ItensPage.vue'), meta: { requiresAuth: true, title: 'Itens no app', breadcrumb: 'Auditoria de Comodato / Itens no app' } },
      { path: 'consolidado', name: 'AudComodatoConsolidado', component: () => import('@/views/AuditoriaComodato/ConsolidadoPage.vue'), meta: { requiresAuth: true, title: 'Consolidado fiscal', breadcrumb: 'Auditoria de Comodato / Consolidado fiscal' } },
      { path: 'aparelhos', name: 'AudComodatoAparelhos', component: () => import('@/views/AuditoriaComodato/AparelhosPage.vue'), meta: { requiresAuth: true, title: 'Aparelhos', breadcrumb: 'Auditoria de Comodato / Aparelhos' } },
    ],
  },
];
export default auditoriaComodatoRoutes;
